import { render, staticRenderFns } from "./RequestCard.vue?vue&type=template&id=1b2e8c00&scoped=true&"
import script from "./RequestCard.vue?vue&type=script&lang=js&"
export * from "./RequestCard.vue?vue&type=script&lang=js&"
import style0 from "./RequestCard.vue?vue&type=style&index=0&id=1b2e8c00&scoped=true&lang=css&"
import style1 from "./RequestCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2e8c00",
  null
  
)

export default component.exports